import {
  MENU_LIST_REQUEST,
  MENU_LIST_SUCCESS,
  MENU_LIST_FAILURE,
  MENU_ITEM_UPDATE_REQUEST,
  MENU_ITEM_UPDATE_SUCCESS,
  MENU_ITEM_UPDATE_FAILURE,
} from "../constants/menuConstants";

// Nested structure: categories[] -> sub_categories[] -> products[]
function updateProductInCategories(categories, productId, productVariant, isActive) {
  return (categories || []).map((cat) => ({
    ...cat,
    sub_categories: (cat.sub_categories || []).map((sub) => ({
      ...sub,
      products: (sub.products || []).map((p) => {
        const match =
          (p.id ?? p.product ?? p.product_id) === productId &&
          (p.product_variant ?? p.variant_id ?? null) === (productVariant ?? null);
        if (!match) return p;
        const storePrices = Array.isArray(p.store_product_price)
          ? p.store_product_price.map((sp) => ({ ...sp, is_active: isActive }))
          : p.store_product_price;
        return { ...p, is_active: isActive, store_product_price: storePrices };
      }),
    })),
  }));
}

export const menuListReducer = (state = { categories: [], loading: false, error: null }, action) => {
  switch (action.type) {
    case MENU_LIST_REQUEST:
      return { ...state, loading: true, error: null };

    case MENU_LIST_SUCCESS:
      return {
        ...state,
        loading: false,
        categories: Array.isArray(action.payload) ? action.payload : [],
        error: null,
      };

    case MENU_LIST_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
        categories: [],
      };

    case MENU_ITEM_UPDATE_REQUEST:
      return { ...state, updatingId: action.payload };

    case MENU_ITEM_UPDATE_SUCCESS: {
      const { product, product_variant, is_active } = action.payload;
      const categories = updateProductInCategories(
        state.categories,
        product,
        product_variant,
        is_active
      );
      return {
        ...state,
        categories,
        updatingId: null,
      };
    }

    case MENU_ITEM_UPDATE_FAILURE:
      return {
        ...state,
        updatingId: null,
        error: action.payload?.error || action.payload,
      };

    default:
      return state;
  }
};
